import { CatHeading } from '@blocks-react/components/Heading';
import { CustomerAccountNoActiveEquipmentHeaderProps } from '../../types';

export const CustomerAccountNoActiveEquipmentHeader = ({
  children
}: CustomerAccountNoActiveEquipmentHeaderProps) => {
  return <CatHeading variant="label-lg">{children}</CatHeading>;
};
